import React from "react";
import "./Loading.css";

export default function Loading({ position, height, hideNavbar }) {
	if (position === "relative") {
		return (
			<div
				className={`flex justify-center items-center w-full ${height || ""}`}
			>
				<div className="loader" />
			</div>
		);
	}

	return (
		<div
			className={`absolute top-0 left-0 h-screen w-full flex justify-center items-center ${hideNavbar ? "z-40" : "z-20"}`}
		>
			<div className="absolute w-full h-full bg-white" />
			<div className="z-50 relative">
				<div className="loader" />
			</div>
		</div>
	);
}
